import * as occlTemplates from '@src/components/templates/occl/index.js';
import * as tefOneTemplates from '@src/components/templates/tefOne/index.js';

export const templates = {
  occl: occlTemplates,
  tefOne: tefOneTemplates as unknown as typeof occlTemplates,
};

export type TemplatesType = typeof tefOneTemplates;
export type TemplateNames = keyof typeof occlTemplates;
